import React, { useState } from 'react'
import { arrowLeft, bell, lock, maths, message, notification, rating, saved, searchs } from '../../assets'
import Subjects from './Subjects'
import { fake } from '../../faker'
import AvatarImage from './../../components/avatarImage'
import { Link } from 'react-router-dom'
import { VideoModal } from '../../components/Generic'
import Comments from '../../components/Comments'

const Explore = ({notifications}) => {
    const [isVidModalOpen, setisVidModalOpen] = useState(false);
    const [isChildValueFalse, setIsChildValueFalse] = useState(false);

    const handleChildValueChange = (newValue) => {
        setIsChildValueFalse(newValue);
      };
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(isChildValueFalse);
  };

    function numberToArray(number) {
        return Array(number).fill().map((_, index) => index);
      }
      
      const rate = 5; // Replace this with your constant number
      const resultArray = numberToArray(rate);
      console.log(resultArray);
      const locked=true
  return (
    <div>
        <div className='flex justify-between items-center mt-[60px] sm:mr-[100px] mr-[24px]'>
            <div className=' ml-[27px] md:ml-[100px] text-[25px] font-medium'>Tutor Chat</div>
            <div className='flex gap-[24px] items-center'>
                <div>
                    {
                        notifications ?
                        <img src={notification} alt="note" />
                        : <img src={bell} alt="note" /> 
                    }
                </div>
                <Link to='/message'><img src={message} alt="message" /></Link>
            </div>
        </div>
        <div className='font-[Poppins] text-[24px] font-normal mt-[58px] ml-[27px] sm:ml-[100px]'>Start Learning</div>
        <div className='mx-[27px] mt-[20px] sm:ml-[100px]'>
        <Link to='/search' className='rounded-[12px]   mt-[13px] items-center flex w-full md:w-[480px] h-[48px]'>
            <div className='pl-[16px] pr-[12px]'><img className='opacity-40 w-[24px] h-[24px]' src={searchs} alt="" /></div>
            <input className='outline-none border-none sm:text-[18px] text-gray-usersGray bg-inherit w-full' type="text" placeholder='what you want to learn?' />
        </Link>
        </div>
        <div className=' '> 
        <div className='flex gap-[10px] overflow-x-auto scroll mt-[32px] ml-[30px] sm:ml-[100px] '>
            { fake.map((item)=>(
                <Subjects/>
                ))}
        </div>
                </div>
        <div className='mt-[17px] flex gap-[10px] items-center ml-[7px] sm:ml-[50px]'>
            <AvatarImage style={`w-[35px] h-[35px] sm:w-[50px] sm:h-[50px]`}/>
            <div className='text-[17px] sm:text-[21px]'>Username</div>
        </div>
            
        <div className='sm:ml-[50px] flex flex-wrap gap-[20px] overflow-hidden'>
            {
                fake.map((item)=>(
                    <div className='w-full sm:w-[500px]'>
                <div className='h-[270px] flex justify-center relative sm:h-[330px]  overflow-hidden'>
                    {
                        locked &&
                    <Link to='/about' className='absolute flex justify-center items-center w-full sm:w-[500px] overflow-hidden top-0 left-0 h-[300px]'>
                    <div className='absolute w-full sm:w-[500px] z-[5] top-0 left-0 h-[240px] sm:h-[330px] bg-gray-opacityGray opacity-40'></div>
                    <div className='z-[10] flex justify-center flex-col gap-[17px] items-center relative'>
                        <div><img src={lock} alt="" /></div>
                        <div className='text-[Poppins] cursor-pointer text-[12px] bg-blue-buttonBlue px-[15px] py-[5px] rounded-[2px] text-white'>Sotib olish</div>
                    </div>
                    </Link>
                    }
                    <img className='w-full' src={maths} alt="" />
                    <Link to='/about' className='bg-blue-lessonBlue z-[7] absolute rounded-[8px] text-white px-[42px] cursor-pointer text-[Poppins] flex justify-center w-[195px] whitespace-nowrap  py-[10px] font-[500] bottom-[10px] text-[18px]'>Matematika</Link>
                </div>
                <div className='text-blue-darkBlue text-[16px] mt-[-10px] sm:text-[20px] font-[500] pl-[22px]'>Matematika bo’yicha video Kurs(lar)</div>
                <div className='flex justify-between mx-[20px]'>
                    <div className='flex gap-[3px] mt-[10px]'>
                    {
                        resultArray.map((item)=>(
                            <img src={rating} key={item.index} alt="" />
                        ))}
                    </div>
                    <div><img src={saved} alt="" /></div>
                </div>
                <div onClick={openVidModal} className='text-gray-opacityGray text-[14px] mt-[13px] ml-[20px] cursor-pointer sm:text-[18px]'>View all 50 comments</div>
                <div onClick={openVidModal} className='border-solid text-gray-opacityGray shadow-commentShadow sm:text-[18px] cursor-pointer border-[0.5px] border-gray-inputGray px-[20px] mt-[8px] py-[10px]'>Add comment...</div>
            </div>
                ))}
        </div>
        <VideoModal style={`${true}`}  onClose={closeVidModal} comments={true}  isOpen={isVidModalOpen}>
                            <div>
                            <div className='flex justify-between items-center mt-[40px] ml-[40px]'>
                                <div className='z-50 relative' onClick={closeVidModal}><img src={arrowLeft} alt="" /></div>
                                <div className='text-[20px] font-medium'>Comments</div>
                                <div className='w-[50px]'></div>
                            </div>
                            <div className='overflow-x-auto sm:h-[400px] h-[100vh] pb-[100px]'> 
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            <Comments handleChildValueChange={handleChildValueChange}/>
                            </div>
                            <input className='flex justify-center border-box mb-[100px]  w-full rounded-[100px] px-[32px] outline-none h-[50px] bg-gray-inputGray' placeholder='Add Comment'/>
                            <div className='fixed sm:hidden flex justify-center bg-[white] pt-[5px] h-[100px] w-full bottom-[-40px]'>
                            <input className=' border-box mb-[100px]  w-full rounded-[100px] px-[32px] outline-none h-[50px] bg-gray-inputGray' placeholder='Add Comment'/>
                            </div>
                            </div>
                </VideoModal>
    </div>
  )
}

export default Explore